import { StyleSheet } from 'aphrodite';
import { brandPrimary, titles } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	header: {
		color: brandPrimary,
		textAlign: 'center',
		...CssSelectors.allChildren(
			{
				color: titles,
				fontSize: 16,
				marginTop: 14,
			},
			':not(:first-child)'
		),
	},
	heading: {
		fontSize: 24,
		margin: 0,
	},
});
